import { type PropertyLocationRow } from "@/types/propertyLocationRow";
import { AREA_A_PREFECTURES, AREA_B_CITIES } from "../constants/priceMaster";
import { type AreaCode } from "../types";

const normalizeAreaText = (value: string): string =>
  value
    .replace(/[０-９]/g, (character) =>
      String.fromCharCode(character.charCodeAt(0) - 0xfee0)
    )
    .replace(/\s+/g, "")
    .trim();

export const classifyArea = (
  property: Pick<PropertyLocationRow, "prefName" | "location">,
  isIsland: boolean
): AreaCode => {
  if (isIsland) return "D";

  const prefName = normalizeAreaText(property.prefName);
  if (
    AREA_A_PREFECTURES.some((areaAPrefecture) => areaAPrefecture === prefName)
  ) {
    return "A";
  }

  const location = normalizeAreaText(property.location);
  const areaBCities = AREA_B_CITIES[prefName] ?? [];
  if (areaBCities.some((city) => location.startsWith(city))) {
    return "B";
  }

  return "C";
};
